import { DEFAULT_STATE } from '../constants'

export const initialDesignersState = {
  designers: DEFAULT_STATE.designers,
}
